import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: 1000,
    color: '#fff'
  }
}))

function FullscreenLoading(props) {
  const classes = useStyles()

  return (
    <Backdrop className={classes.backdrop} open={props.open}>
      <CircularProgress color='secondary' />
    </Backdrop>
  )
}

FullscreenLoading.defaultProps = {
  open: false
}

export default FullscreenLoading
